import { clsx } from 'clsx';
import { IconButton } from '../../../button/IconButton/IconButton';
import { Icon } from '../../../icon/Icon';

interface EntityMenuActionButtonProps {
  target: string;
  disabled?: boolean;
  label: string;
  disabledLabel?: string;
  className?: string;
  onClick: VoidFunction;
  iconSize?: number;
}

export function EntityMenuActionButton({
  target,
  disabled,
  onClick,
  label,
  disabledLabel,
  className,
  iconSize
}: EntityMenuActionButtonProps) {
  return (
    <IconButton
      dataId={target}
      label={disabled ? disabledLabel! : label}
      id={target}
      disabled={disabled}
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
      className={clsx(className)}
    >
      <Icon name='more-vertical' size={iconSize || 3} dataId={target} />
    </IconButton>
  );
}
